// Formats a practice row's secondary "doctor" line, mirroring UserCell's
// stacked name/email pattern. Practices whose doctorName already carries a
// "Dr" honorific (however it was entered) are shown as-is instead of
// doubling it. Shared by PracticesTable and the Accounts Overview hub's
// "Practices needing attention" card - kept in its own file (not exported
// from PracticesTable.tsx) so pulling it in doesn't trip
// react-refresh/only-export-components on that component file.
export function formatDoctorLine(doctorName: string | null): string | null {
    if (!doctorName) return null;
    const trimmed = doctorName.trim();
    if (!trimmed) return null;
    if (/^dr\.?\s/i.test(trimmed)) return trimmed;
    return `Dr. ${trimmed}`;
}
